import { render } from "./AddEditSurcharges.vue?vue&type=template&id=3633bf30&scoped=true"
import script from "./AddEditSurcharges.vue?vue&type=script&lang=js"
export * from "./AddEditSurcharges.vue?vue&type=script&lang=js"

import "./AddEditSurcharges.vue?vue&type=style&index=0&id=3633bf30&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3633bf30"]])

export default __exports__